module.exports = __webpack_public_path__ + "img/solution--improve-patient-experience.2f79a1fd.png";